import React, { useState, useEffect, useContext } from 'react'
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { parseJwt } from '../genericFunction';
import { getMenuMode } from '../helperTableFunctions';
import { UserDetailsContext } from '../../App';

export function GoogleAnalytics(props) {

    const location = useLocation();

    const [lastPageAccessed, setLastPageAccessed] = useState("");
    const [orgData, setOrgData] = useState(null);
    let { userDetails, setUserDetails } = useContext(UserDetailsContext)

    const [isOrgReady, setIsOrgReady] = useState(false);

    useEffect(() => {
        ReactGA.initialize("G-TV9BYWW7PS");
    }, [])

    useEffect(() => {
        let token = sessionStorage.getItem("token");
        let tokenData = parseJwt?.(token);

        const orgName = tokenData?.schemaEntName;
        const orgId = tokenData?.schemaEntID;

        if (orgName && orgId) {
            const newOrg = { orgName, orgId };

            setOrgData(prev => {
                if (
                    prev?.orgId !== orgId ||
                    prev?.orgName !== orgName
                ) {
                    ReactGA.set({
                        user_properties: {
                            organization_name: orgName,
                            organization_id: orgId
                        }
                    });
                    return newOrg;
                }
                return prev;
            });

            setIsOrgReady(true);
        }
    }, []);

    const getParentModule = (module, fallback) => {
        let subModules = module.subModules;

        if (subModules) {
            const HASH = `#${location.pathname}`;

            for (let i = 0; i < subModules.length; i++) {
                if (subModules[i].pageUrl === HASH) {
                    return {
                        parent:
                            getMenuMode() == "new"
                                ? (module.isPage == 1 ? fallback || module : module)
                                : (module.isPage == 1 ? fallback : module),
                        title: subModules[i].name
                    };
                } else {
                    let temp = getParentModule(subModules[i], module);
                    if (temp?.parent) return temp;
                }
            }
        }

        return {};
    };

    let dashboardModules = getMenuMode?.() == 'new' ? JSON.parse(userDetails?.mainMenu || "{}")?.dashboardModules || [] : JSON.parse(userDetails?.dashboardModules || "[]");


    useEffect(() => {
        if (!isOrgReady) return;
        let updatedParentModule = {};
        let pageTitle = "";

        if (getMenuMode() == "new") {
            let modules = JSON.parse(userDetails?.mainMenu || "{}");
            let listOfModules = modules?.["moduleList"]?.[0];

            if (listOfModules && listOfModules.length) {
                for (let i = 0; i < listOfModules.length; i++) {
                    let res = getParentModule(listOfModules[i]);
                    if (res?.parent) {
                        updatedParentModule = res.parent;
                        pageTitle = res.title;
                        break;
                    }
                }
            }

            if (!updatedParentModule || Object.keys(updatedParentModule).length === 0) {
                let res = getParentModule({
                    code: "CREATE",
                    crud: "1111",
                    name: "Create",
                    icon_url: "create-icon.svg",
                    subModules: modules?.createModuleList?.map(item => ({
                        ...item,
                        name: item?.module_name || "",
                        pageUrl: item?.page_url
                    }))
                });

                if (res?.parent) {
                    updatedParentModule = res.parent;
                    pageTitle = res.title;
                }
            }

        } else {
            let modules = JSON.parse(userDetails?.modules || "[]");
            if (modules && modules.length) {
                for (let i = 0; i < modules.length; i++) {
                    let res = getParentModule(modules[i]);
                    if (res?.parent) {
                        updatedParentModule = res.parent;
                        pageTitle = res.title;
                        break;
                    }
                }
            }
        }

        let path = location?.pathname;

        let moduleName = dashboardModules?.find(item => item?.pageUrl?.includes(path))?.name;

        let finalTitle = (parseJwt(sessionStorage?.getItem('token'))?.subUserType == "T" && moduleName == "Order Tracking") ? "Transporter Dashboard" : pageTitle || moduleName || "Supplymint";

        // // ✅ Set title ONCE
        // document.title = finalTitle;
        const prevUrl = lastPageAccessed?.path ? window.location.origin + lastPageAccessed.path : "direct";
        if (location.pathname != lastPageAccessed?.path && location.pathname && !["quality.supplymint.com", "dev.supplymint.com"]?.some(item => window.location.hostname?.includes(item))) {
            // On locatiojn change fire the ga4 socket event;
            ReactGA.send({ hitType: "pageview", page: location.pathname, title: finalTitle, page_referrer: prevUrl, previous_page: lastPageAccessed?.title || "direct" });

            setLastPageAccessed({ path: location.pathname, title: finalTitle });
        }
    }, [location, isOrgReady]);

    return <React.Fragment>

    </React.Fragment>
}